export const MANAGEMENT_NO_TAG_FILTER = "Aucun tag";

export type TagFilterOption = {
    id: number;
    name: string;
    color?: number;
    displayName?: string;
};

export function withManagementEmptyTagFilterOption<T extends TagFilterOption>(tags: T[], emptyLabel: string): T[] {
    return [{ id: 0, name: MANAGEMENT_NO_TAG_FILTER, displayName: emptyLabel } as T, ...tags];
}
